import styled, { css } from 'styled-components'
import { theme } from './../../common'
import { Row } from 'react-bootstrap'

export const StyledTitle = styled.h1`
    font-size: 2.7em;
    font-weight: bold;
    text-transform: uppercase;
    color: ${({ primary }) => primary ? theme.white : theme.grey};
`

export const StyledContent = styled.div`
    color: ${({ primary }) => primary ? theme.white : theme.grey};
`

export const CardContainer = styled(Row)`
    padding: 10% 0;
`